import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["open", "data-testid", "onToggle"]
const _hoisted_3 = { class: "flex cursor-pointer list-none flex-wrap items-center gap-2.5 px-3.5 py-2.5 font-bold" }
const _hoisted_4 = { class: "text-sm font-medium tabular-nums text-neutral50" }
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = { class: "border-t border-lightGray30" }

import { computed } from 'vue'

import { QUEUE_TONE_PILL_CLASS } from './types'
import type { QueueGroup } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'QueueGroupedList',
  props: {
    groups: {},
    countLabel: { type: Function, default: undefined },
    testId: { default: 'queue-grouped-list' }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }) {

const props = __props;





// Seção vazia é ruído: quem abre a Lista quer ver o que exige ação, não seis
// títulos com zero embaixo.
const visibleGroups = computed(() => props.groups.filter((group) => group.rows.length > 0))

function onToggle(key: string, event: Event): void {
  emit('toggle', key, (event.target as HTMLDetailsElement).open)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex w-full flex-col gap-2.5",
    "data-testid": _ctx.testId
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleGroups.value, (group) => {
      return (_openBlock(), _createElementBlock("details", {
        key: group.key,
        open: group.defaultOpen === true,
        class: "rounded-lg border border-lightGray30 bg-white",
        "data-testid": `${_ctx.testId}-group-${group.key}`,
        onToggle: ($event: any) => (onToggle(group.key, $event))
      }, [
        _createElementVNode("summary", _hoisted_3, [
          _renderSlot(_ctx.$slots, "title", { group: group }, () => [
            _createElementVNode("span", {
              class: _normalizeClass(["rounded-full px-2 py-0.5 text-xs font-medium", _unref(QUEUE_TONE_PILL_CLASS)[group.tone ?? 'neutral']])
            }, _toDisplayString(group.title), 3)
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.countLabel ? _ctx.countLabel(group) : `${group.rows.length} itens`), 1),
          (group.hint)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "text-xs font-normal text-neutral50",
                "data-testid": `${_ctx.testId}-group-${group.key}-hint`
              }, _toDisplayString(group.hint), 9, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default", { group: group })
        ])
      ], 40, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}
}

})